export {
  getLocalDataOwnerUserId,
  setLocalDataOwnerUserId,
  clearLocalDataOwnerUserId,
} from '../../shared/localDb';

export type StockSalePolicy = 'block' | 'warn' | 'allow';

const DEFAULT_STOCK_SALE_POLICY: StockSalePolicy = 'block';

/** Política POS por sucursal (`public.branches.stock_sale_policy`), vía sesión actual. */
export function getStockSalePolicyForBranch(branchId: string | null | undefined): StockSalePolicy {
  if (!branchId) return DEFAULT_STOCK_SALE_POLICY;
  const { useSessionStore } = require('./store/useSessionStore') as typeof import('./store/useSessionStore');
  const branch = useSessionStore.getState().branches.find((b) => b.id === branchId);
  return branch?.stockSalePolicy ?? DEFAULT_STOCK_SALE_POLICY;
}

/** Limpia clave legada en SQLite (antes la política era global en el equipo). */
export async function clearLegacyLocalStockSalePolicy(): Promise<void> {
  // No-op: SQLite eliminado (ADR-017 Fase 4).
}
